import { render } from "./AppBaseFilters.vue?vue&type=template&id=c5acd97a&scoped=true"
import script from "./AppBaseFilters.vue?vue&type=script&lang=js"
export * from "./AppBaseFilters.vue?vue&type=script&lang=js"

import "./AppBaseFilters.vue?vue&type=style&index=0&id=c5acd97a&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5acd97a"]])

export default __exports__